"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
/* eslint-disable */
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20.334 9.293a.833.833 0 0 1 1.666 0v7.917a.833.833 0 0 1-1.666 0v-.833a.417.417 0 0 0-.417-.417H4.084a.417.417 0 0 0-.417.417v.833a.833.833 0 0 1-1.667 0V6.793a.833.833 0 0 1 1.667 0v7.084c0 .23.187.416.417.416h15.833c.23 0 .417-.186.417-.416V9.293Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 13.252h8.89a.694.694 0 0 0 .519-1.155c-1.714-1.929-5.159-3.119-9.151-3.004a.694.694 0 0 0-.674.694v3.048c0 .23.186.417.416.417ZM6.167 13.252a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z"
})), "0 0 24 24", "Accommodation");
exports.default = _default;